import { atomFamily } from 'recoil';

export const makePHPRequestPayload = atomFamily({
  key: 'makePHPRequestPayload', // unique ID (with respect to other atoms/selectors)
  default: null,
  // default value (aka initial value)
});
